// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_60-7";
export var adjustableWidthBorderHeld = "_60-8";
export var arrow = "_60-3";
export var arrowButton = "_60-4";
export var headerCell = "_60-0";
export var help = "_60-2";
export var icon = "_60-1";
export var iconWrapper = "_60-6";
export var noBorder = "_60-b";
export var nonAdjustableWidthBorder = "_60-9";
export var nonAdjustableWidthBorderHeld = "_60-a";
export var textButton = "_60-5";